
























































































































import Vue, { PropOptions } from "vue";
import { mask } from "vue-the-mask";
import CampaignService from "../../services/CampaignService";
import {
  audienceCustomerListRules,
  campaignMessageTokenRules,
} from "@/rules/campaign.rules";
import {
  CampaignAudienceFileTokenMapping,
  CampaignMessageToken,
  Campaign,
} from "@/models";

export default Vue.extend({
  props: {
    campaign: Object as PropOptions<Campaign>,
    isMobile: Boolean,
  },
  directives: {
    mask,
  },
  data() {
    return {
      phoneMask: "# ####-####",
      dddMask: "###",
      rules: {
        ...audienceCustomerListRules.attr,
        token: {
          ...campaignMessageTokenRules.attr,
        },
      },
    };
  },
  watch: {
    "campaign.textMessage"(val) {
      // const newTokens = CampaignService.extractTokensFromText(val);
      // if (this.campaign.audienceCustomerList) {
      //   this.campaign.audienceCustomerList =
      //     this.campaign.audienceCustomerList.map((item: any) => {
      //       const newMessageTokens = [];
      //       for (const token of newTokens) {
      //         const found = item.tokens.find(
      //           (t: CampaignMessageToken) => t.name === token
      //         );
      //         if (!found) {
      //           newMessageTokens.push({ name: token, value: "" });
      //         } else {
      //           newMessageTokens.push(found);
      //         }
      //       }
      //       item.tokens = newMessageTokens;
      //       return item;
      //     });
      // }
    },
  },
  methods: {
    addCustomer() {
      const newAudienceCustomerList = [
        ...(this.campaign.audienceCustomerList || []),
        {
          phoneCountryCode: "55",
          phoneAreaCode: "",
          phoneNumber: "",
          tokens: this.getMessageTokensMapped() || [],
        },
      ];
      this.$emit("update", {
        audienceCustomerList: newAudienceCustomerList,
      });
    },
    setToken(index, event) {
      this.campaign.audienceCustomerList[index].tokens = [
        {
          name: "{{nome}}",
          value: event,
        },
      ];

      this.$emit("update", {
        audienceCustomerList: [...this.campaign.audienceCustomerList],
      });
    },
    removeCustomer(index: number) {
      this.campaign.audienceCustomerList.splice(index, 1);
      this.$emit("update", {
        audienceCustomerList: [...this.campaign.audienceCustomerList],
      });
    },
    getTokens() {
      return CampaignService.extractTokensFromText(this.campaign.textMessage);
    },
    getMessageTokensMapped(): CampaignMessageToken[] {
      return this.getTokens().map((v) => ({ name: v, value: "" }));
    },
  },
});
